module.exports = __webpack_public_path__ + "public/img/duty2.0486ed2b.png";